import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BookShipmentComponent } from './pages/book-shipment/book-shipment.component';
import { HomeComponent } from './pages/home/home.component';
import { QrComponent } from './pages/qr/qr.component';
import { TrackingComponent } from './pages/tracking/tracking.component';

export const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'book-shipment', component: BookShipmentComponent, canActivate: [MsalGuard]  },
  { path: 'tracking/:filter', component: TrackingComponent, canActivate: [MsalGuard]  },
  { path: 'shipments/:courier/:shipmentId', component: QrComponent, canActivate: [MsalGuard] },
  
  // catch all and redirect to home
  { path: '**', redirectTo: 'home' }
];
